import { memo, useEffect, useState } from 'react';
import { useApp } from '../../../../hook/app.hook';
import { Question, Section } from '../../../../response/test.response';

const JeeSummaryComponent = () => {
  const { testRes } = useApp();

  const [summary, setSummary] = useState({
    notVisitedCount: 0,
    notAnsweredCount: 0,
    answeredCount: 0,
    markedForReviewCount: 0,
    answeredAndMarkedCount: 0,
  });

  const getQuestionStatus = (question: Question) => {
    const visited =
      question.timeTaken > 0 ||
      (question.attempted && question.saved) ||
      question.markedForRevisit ||
      question.active;

    if (!visited) return 'not-visited';
    if (question.attempted && question.saved && question.markedForRevisit)
      return 'answered-and-marked';
    if (question.attempted && question.saved) return 'answered';
    if (question.markedForRevisit) return 'marked-for-review';
    return 'not-answered';
  };

  useEffect(() => {
    let _notVisitedCount = 0;
    let _notAnsweredCount = 0;
    let _answeredCount = 0;
    let _markedForReviewCount = 0;
    let _answeredAndMarkedCount = 0;

    testRes.sectionList.forEach((section: Section) => {
      section.questionList.forEach((question: Question) => {
        const status = getQuestionStatus(question);
        if (status === 'not-visited') {
          _notVisitedCount++;
        } else if (status === 'not-answered') {
          _notAnsweredCount++;
        } else if (status === 'answered') {
          _answeredCount++;
        } else if (status === 'marked-for-review') {
          _markedForReviewCount++;
        } else if (status === 'answered-and-marked') {
          _answeredAndMarkedCount++;
        }
      });
    });

    setSummary({
      notVisitedCount: _notVisitedCount,
      notAnsweredCount: _notAnsweredCount,
      answeredCount: _answeredCount,
      markedForReviewCount: _markedForReviewCount,
      answeredAndMarkedCount: _answeredAndMarkedCount,
    });
  }, [testRes]);

  return (
    <div
      className="border border-secondary m-2 rounded"
      style={{ borderStyle: 'dashed' }}
    >
      <div className="d-flex flex-column gap-2">
        {/* Not Visited */}
        <div className="d-flex align-items-center gap-2">
          <div
            className="d-flex align-items-center justify-content-center rounded"
            style={{
              width: '40px',
              height: '30px',
              backgroundColor: '#e0e0e0',
              color: '#666',
              fontWeight: '600',
              fontSize: '14px',
            }}
          >
            {summary.notVisitedCount}
          </div>
          <span className="small">Not Visited</span>
        </div>

        {/* Not Answered */}
        <div className="d-flex align-items-center gap-2">
          <div
            className="d-flex align-items-center justify-content-center"
            style={{
              width: '40px',
              height: '30px',
              backgroundColor: '#dc3545',
              color: 'white',
              fontWeight: '600',
              fontSize: '14px',
              clipPath: 'polygon(10% 0%, 90% 0%, 100% 100%, 0% 100%)',
            }}
          >
            {summary.notAnsweredCount}
          </div>
          <span className="small">Not Answered</span>
        </div>

        {/* Answered */}
        <div className="d-flex align-items-center gap-2">
          <div
            className="d-flex align-items-center justify-content-center"
            style={{
              width: '40px',
              height: '30px',
              backgroundColor: '#28a745',
              color: 'white',
              fontWeight: '600',
              fontSize: '14px',
              clipPath: 'polygon(10% 0%, 90% 0%, 100% 100%, 0% 100%)',
            }}
          >
            {summary.answeredCount}
          </div>
          <span className="small">Answered</span>
        </div>

        {/* Marked for Review */}
        <div className="d-flex align-items-center gap-2">
          <div
            className="d-flex align-items-center justify-content-center rounded-circle position-relative"
            style={{
              width: '35px',
              height: '35px',
              backgroundColor: '#6f42c1',
              color: 'white',
              fontWeight: '600',
              fontSize: '14px',
            }}
          >
            {summary.markedForReviewCount}
          </div>
          <span className="small">Marked for Review</span>
        </div>

        {/* Answered & Marked for Review */}
        <div className="d-flex align-items-center gap-2">
          <div
            className="d-flex align-items-center justify-content-center rounded-circle position-relative"
            style={{
              width: '35px',
              height: '35px',
              backgroundColor: '#6f42c1',
              color: 'white',
              fontWeight: '600',
              fontSize: '14px',
            }}
          >
            {summary.answeredAndMarkedCount}
            <div
              className="position-absolute"
              style={{
                width: '12px',
                height: '12px',
                backgroundColor: '#28a745',
                bottom: '2px',
                right: '2px',
              }}
            />
          </div>
          <span className="small">
            Answered & Marked for Review (will be considered for evaluation)
          </span>
        </div>
      </div>
    </div>
  );
};

export default memo(JeeSummaryComponent);
